const employee = {

    // headings
    createProfessor: 'Create Professor',
    editProfessor: 'Edit Professor',

    createStaff: 'Create Staff',
    editStaff: 'Edit Staff',

    createAbsence: 'Create New Absence/Holiday Request',

    // List
    professorList: 'Professor List',
    staffList: 'Staff List',
    absenceList: 'Absence List',
    reasonList: 'Absence Types',
    reasonCreate: 'Add Absence Type',
    reasonEdit: 'Edit Absence Type',
    holidayList: 'Local Holidays List',
    holidayCreate: 'Create Local Holidays',
    holidayEdit: 'Edit Local Holidays',
    searchCriteria: 'Filter Preset',
    name: 'Name',
    postalCode: 'Postal Code',
    presetName: 'Enter Preset Name',
    action: 'Action',
    vacationBalancePerYear: 'Vacation Balance Per Year',
    totalVacationBalance: 'Total Vacation Balance',
    workload: 'Workload (Percentage)',
    status: 'Status',

    // Tabs
    tabPersonal: 'Personal Information',
    tabBusiness: 'Business Information',
    tabRemarks: 'Remarks',
    tabCourses: 'Courses',
    tabContracts: 'Contracts',
    tabAudit: 'Audit Log',
    tabAbsence: 'Absence Management',

    // Personal Tab
    photo: 'Photo',
    title: 'Title',
    firstName: 'First Name',
    lastName: 'Last Name',
    birthDate: 'Birth Date',
    birthPlace: 'Birth Place',
    birthCountry: 'Birth Country',
    department: 'Department',
    position: 'Position',
    streetAddress: 'Street Address',
    city: 'City',
    zip: 'Zip',
    country: 'Country',
    phone: 'Phone',
    mobile: 'Mobile',
    fax: 'Fax',
    email: 'Email',
    email2: 'Email 2',
    email3: 'Email 3',
    webAddress: 'Web Address',
    notes: 'Notes',
    vacationBalance: 'Vacation Balance Per Year (In Days)',
    mailAddress: 'Mail Address',
    mailAddressOption1: 'Personal Address',
    mailAddressOption2: 'Business Address',
    // Business Tab
    companyName: 'Company Name',
    department: 'Department',
    position: 'Position',
    fax: 'Fax',
    contactPerson: 'Contact Person:',

    // Remarks Tab
    remarks: 'Remarks',

    // Courses Tab
    course: 'Course',
    program: 'Program',
    academicYear: 'Academic Year',
    term: 'Term',
    searchCourse: 'Search by Course Title',
    searchProgram: 'Search by Program Title',

    // Contracts Tab
    file: 'File',
    fileName: 'Name',
    fileDescription: 'Description',
    fileAttach: 'Attach File:',
    fileAttachDrop: 'Click or Drag a file(s) here to upload.',

    // Absence Management
    vacationBalanceAdjustment: 'Vacation Balance Adjustments',
    vacationBalanceAdjustmentAdd: 'Add Vacation Balance Adjustment',
    vacationDay: 'Days',
    vacationAdd: 'Add',
    vacationSub: 'Subtract',
    vacationType: 'Type',
    vacationRemark: 'Remarks',
    vacationDate: 'Date',
    vacationOwner: 'Added By',

    // absence
    absenceType: 'Staff Name',
    absenceFrom: 'From',
    absenceTo: 'To',
    absenceDuration: 'Duration',
    absenceReason: 'Reason',
    absenceStatus: 'Status',
    absenceBy: 'Accepted By',
    absenceRemarks: 'Remarks',
    deductible: 'Deductible',
    addRemarks: 'Please add a Remarks (Optional)',

    // Action Labels
    approved: 'Approved',
    approve: 'Approve',
    rejected: 'Rejected',
    reject: 'Reject',
    pending: 'Pending',

    // Local Holidays
    holiday: 'Holiday',
    from: 'From',
    to: 'To',
    date: 'Date (DD.MM.*)',
    yearly: 'Annual',
    setYearly: 'Set as Annual?'

};

export default employee;